import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Skeleton from '@material-ui/lab/Skeleton';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Avatar from '@material-ui/core/Avatar';
import CardActionArea from '@material-ui/core/CardActionArea';
import { useHistory } from 'react-router-dom';
import useRules from '../../../../../../hooks/useRules';

const CardItem = ({ title, link, statistics, icon, loading }) => {
  const history = useHistory();
  const [rules,hasRule] = useRules();
  return (
    <Grid item xs={6} sm={6} md={3}>
      {loading ? (
        <Skeleton variant="text" animation="wave" height={112} />
      ) : (
        <Card>
          <CardActionArea onClick={() => history.push(link)}>
            <CardHeader
              avatar={<Avatar variant="rounded" alt={title} src={icon} />}
              title={title}
              subheader={hasRule('dashboard_can_see_statistics_count')?statistics:''}
            />
          </CardActionArea>
        </Card>
      )}
    </Grid>
  );
};

export default React.memo(CardItem);
